/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IXERC20Factory,
  IXERC20FactoryInterface,
} from "../IXERC20Factory";

const _abi = [
  {
    inputs: [],
    name: "IXERC20Factory_BadTokenAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "IXERC20Factory_InvalidLength",
    type: "error",
  },
  {
    inputs: [],
    name: "IXERC20Factory_LockboxAlreadyDeployed",
    type: "error",
  },
  {
    inputs: [],
    name: "IXERC20Factory_NotOwner",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_lockbox",
        type: "address",
      },
    ],
    name: "LockboxDeployed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_xerc20",
        type: "address",
      },
    ],
    name: "XERC20Deployed",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string",
      },
      {
        internalType: "uint256[]",
        name: "_minterLimits",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "_burnerLimits",
        type: "uint256[]",
      },
      {
        internalType: "address[]",
        name: "_bridges",
        type: "address[]",
      },
    ],
    name: "deployXERC20",
    outputs: [
      {
        internalType: "address",
        name: "_xerc20",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_xerc20",
        type: "address",
      },
      {
        internalType: "address",
        name: "_baseToken",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_isNative",
        type: "bool",
      },
    ],
    name: "deployLockbox",
    outputs: [
      {
        internalType: "address payable",
        name: "_lockbox",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class IXERC20Factory__factory {
  static readonly abi = _abi;
  static createInterface(): IXERC20FactoryInterface {
    return new utils.Interface(_abi) as IXERC20FactoryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IXERC20Factory {
    return new Contract(address, _abi, signerOrProvider) as IXERC20Factory;
  }
}
